
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.35265',
  depVersions: {
  "documents-public-ui": "static-1.35265",
  "atom": "static-1.5416",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2815",
  "client-types": "static-1.501",
  "cssUtils": "static-1.956",
  "customer-data-filters-ui": "static-1.41005",
  "customer-data-objects": "static-1.8032",
  "customer-data-property-utils": "static-1.8432",
  "documents-lib": "static-1.35270",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.372",
  "FormsCommonComponents": "static-1.86634",
  "FormUrlGenerator": "static-2.5060",
  "foundations-theming-specialty": "static-1.2527",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.111",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5924",
  "hs-test-utils": "static-1.8367",
  "hub-http": "static-1.6546",
  "hubspot-dlb": "static-2.1905",
  "HubStyle": "static-2.12132",
  "HubStyleTokens": "static-2.11825",
  "I18n": "static-7.1678",
  "icons": "static-2.692",
  "jasmine-immutable": "static-1.3354",
  "jasmine-runner": "static-1.6784",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7487",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.3227",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5729",
  "quartz": "static-1.7497",
  "react": "static-7.196",
  "react-dlb": "static-1.89",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.79",
  "react-rhumb": "static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5578",
  "react-virtualized": "static-2.107",
  "reference-resolvers": "static-1.8514",
  "reference-resolvers-lite": "static-1.8438",
  "reporting-data": "static-1.68903",
  "reporting-reports": "static-1.68580",
  "reporting-snowflake": "static-1.57520",
  "reporting-testing-lib": "static-1.10836",
  "reporting-visualizations": "static-1.60978",
  "reselect": "static-3.12",
  "sales-content-partitioning": "static-1.9286",
  "sanitize": "static-1.4806",
  "sanitize-text": "static-1.8491",
  "SharedI18nStrings": "static-1.183",
  "SharedLegalStrings": "static-1.2077",
  "signup-constants": "static-1.19677",
  "signup-ui-url-generator": "static-2.8394",
  "StyleGuideUI": "static-3.506",
  "superstore": "static-1.5093",
  "tinymce": "static-6.5",
  "transmute": "static-2.97",
  "ui-addon-draggable": "static-3.5090",
  "ui-addon-form-validation": "static-1.11318",
  "ui-asset-management-lib": "static-1.11432",
  "ui-images": "static-2.1260",
  "UIComponents": "static-3.8771",
  "usage-tracker": "static-1.7647",
  "usage-tracker-container": "static-1.7637",
  "usage-tracker-core": "static-1.7497",
  "viral-links-lib": "static-1.7410",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9987",
  "foundations-components": "static-1.8537",
  "immutable": "static-2.87",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1275",
  "quartz-core": "static-1.6716",
  "quick-fetch": "static-1.4150",
  "raven": "static-3.5925",
  "redux": "static-4.80",
  "redux-thunk": "static-2.80",
  "rpc-client-utils": "static-1.4999",
  "ui-addon-i18n": "static-1.11480",
  "ui-addon-upgrades": "static-9.18421",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4366",
  "metrics-js": "static-1.9963",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3774",
  "quartz-webpack": "static-1.3721",
  "foundations-assets": "static-1.5220",
  "foundations-theming": "static-1.4811",
  "hub-http-janus": "static-1.886",
  "hub-http-shared-msw-handlers": "static-1.10669",
  "hubspotter-http": "static-1.4886",
  "sassPrefix": "static-1.223",
  "conversations-skeleton-state": "static-1.7582",
  "crm-message-bus": "static-1.43823",
  "customer-data-filters-ui-msw-helpers": "static-1.23440",
  "customer-data-objects-ui-components": "static-1.13365",
  "customer-data-reference-ui-components": "static-1.13513",
  "customer-data-ui-utilities": "static-1.10165",
  "events-data-lib": "static-1.582",
  "framework-builder-read-service-client": "static-1.4244",
  "hs-resources": "static-1.526",
  "immer": "static-1.101",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbound-db-properties-service-client": "static-1.4070",
  "multi-account-reference-resolvers": "static-1.1341",
  "onboarding-scopes": "static-1.6787",
  "onboarding-tours": "static-1.17168",
  "pulse": "static-1.963",
  "reporting-datasets-permissions-lib": "static-1.14519",
  "stylex": "static-1.41",
  "trellis-assets": "static-1.2727",
  "trellis-components": "static-1.2746",
  "trellis-theming": "static-1.1307",
  "ui-addon-teams": "static-1.21943",
  "quartz-auth": "static-1.1172",
  "ui-business-units-lib": "static-1.9425",
  "usage-tracker-session-replay": "static-1.5333",
  "ai-components-ui-library": "static-1.9779",
  "ContentUtils": "static-1.69184",
  "customer-data-properties": "static-1.52675",
  "forms-ai-lib": "static-1.4802",
  "forms-utils-lib": "static-1.13132",
  "foundations-components-test-utils": "static-1.6020",
  "react-dnd-compat": "static-1.4951",
  "react-tinymce": "static-1.56031",
  "tinymce-config": "static-2.55157",
  "ui-gdpr-components": "static-1.10630",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3796",
  "HeadJS": "static-2.802",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3478",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "hs-locale-management": "static-1.317",
  "ui-fonts": "static-1.1087",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4646",
  "csstype": "static-1.50",
  "quartz-head": "static-1.1162",
  "web-vitals": "static-1.15",
  "batch-promise": "static-1.1879",
  "external-options-client-types": "static-1.4363",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7228",
  "quartz-i18n": "static-1.1172",
  "frontend-preferences-client": "static-1.8252",
  "graphql": "static-1.89",
  "persist-promise": "static-1.4036",
  "reporting-client-types": "static-1.2712",
  "apollo-stack-hubspot": "static-3.94",
  "growth-payments-core": "static-1.26243",
  "hubspot-apollo-client": "static-1.5211",
  "foundations-components-legacy": "static-1.1562",
  "quartz-routing": "static-1.927",
  "hs-story-utils": "static-1.9760",
  "react-flip-move": "static-1.78",
  "nested-table": "static-1.569",
  "seat-types-lib": "static-1.793",
  "timezone-utils": "static-2.5577",
  "react-create-root-preference": "static-1.77",
  "bend-plugin-foundations-components": "static-1.4806",
  "floating-ui": "static-1.63",
  "react-aria": "static-1.72",
  "tanstack-table": "static-1.61",
  "opentelemetry-fe-types": "static-1.110",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.582",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.485",
  "quartz-test": "static-1.1172",
  "quartz-tracking": "static-1.876",
  "bend-plugin-chirp-manifest": "static-1.409",
  "chirp-fetch": "static-1.2230",
  "merchandise-lib": "static-1.279",
  "purchase-motions-components": "static-1.6405",
  "ts-schema": "static-1.4316",
  "bender-build-tools": "static-1.3452",
  "bend-plugin-foundations-theming": "static-1.3294",
  "restore-request-side-panel-lib": "static-1.1731",
  "react-immutable-render-mixin": "static-1.9",
  "apollo-link-hub-http": "static-2.4991",
  "conditional-properties-service-client": "static-1.4039",
  "crm-pipelines-api-client-types": "static-1.4370",
  "event-emitter": "static-1.1289",
  "fdsr-migration-layer": "static-1.347",
  "multi-currency-client-types": "static-1.3930",
  "getting-started-shared-tasks": "static-1.19301",
  "growth-data-modal": "static-1.5934",
  "growth-onboarding-confetti": "static-1.3399",
  "growth-onboarding-next-action-utils": "static-1.2743",
  "navigation-components": "static-1.18887",
  "onboarding-tours-client": "static-1.5383",
  "onboarding-tours-utils": "static-1.1235",
  "ui-shepherd-react": "static-3.10603",
  "ui-shepherd-tracker": "static-1.7984",
  "ui-universal-auth": "static-1.9457",
  "user-context": "static-1.5455",
  "bend-plugin-pulse": "static-1.466",
  "fast-json-patch": "static-1.70",
  "stylex-utils": "static-1.146",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "tanstack-virtual": "static-1.38",
  "hubspotter-http-shared-msw-handlers": "static-1.10667",
  "magpie-lib": "static-1.5780",
  "navigation-messaging": "static-1.8214",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.23177",
  "copilot-toolkit": "static-1.11895",
  "cms-field-types": "static-1.5146",
  "content-icons-ui": "static-1.2397",
  "integrations-lib": "static-1.17112",
  "calling-global-api": "static-1.65709",
  "calling-internal-common": "static-1.31656",
  "calling-lifecycle-internal": "static-1.67091",
  "calling-lifecycle-messages": "static-1.59385",
  "commerce-products-lib": "static-1.10599",
  "crm-index-visualization-core": "static-1.4581",
  "crm-links": "static-1.6658",
  "customer-data-properties-shared-msw-handlers": "static-1.9996",
  "file-manager-components": "static-1.24572",
  "formula-editor": "static-1.14810",
  "google-libphonenumber": "static-1.45",
  "inbounddb-objects-service-types": "static-1.4451",
  "meetings-icalendar-utils-lib": "static-1.969",
  "object-builder-ui-client": "static-1.49745",
  "pipeline-validation-client-types": "static-1.4205",
  "property-value-citations": "static-1.3289",
  "smart-data-capture-core": "static-1.188",
  "smart-property-lib": "static-1.8358",
  "tiered-pricing": "static-1.2005",
  "topics-actions-lib": "static-1.503",
  "trial-components-library": "static-1.14156",
  "ui-addon-iframeable": "static-1.9411",
  "zustand": "static-1.85",
  "final-form": "static-1.78",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.78",
  "rich-text-lib": "static-1.20347",
  "tinymce-themes": "static-1.57127",
  "data-token-picker": "static-1.16927",
  "hub-http-contrib": "static-1.3374",
  "interframe": "static-3.5089",
  "tinymce-data": "static-1.41242",
  "tinymce-plugins": "static-1.58271",
  "ui-addon-sales-email": "static-1.5548",
  "framework-data-schema-quick-fetch": "static-1.7133",
  "ui-addon-opt": "static-4.8701",
  "hubspot-apollo-cache": "static-1.670",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.482",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.38",
  "purchase-motions-api": "static-1.6408",
  "onboarding-data-sync-lib": "static-1.2557",
  "growth-onboarding-next-action-components": "static-1.2771",
  "user-context-client": "static-1.4842",
  "idb-keyval": "static-1.51",
  "magpie-types": "static-1.5240",
  "nest": "static-1.571",
  "reactive-lib": "static-1.1053",
  "simple-logging-lib": "static-1.3385",
  "unified-auth-core-lib": "static-1.1253",
  "getting-started-shared-tasks-store": "static-1.18419",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1818",
  "integrations-error-boundary-lib": "static-1.14527",
  "integrations-tracking-lib": "static-1.5942",
  "native-integrations-shared-strings": "static-1.8111",
  "redux-observable": "static-1.75",
  "ReduxMessenger": "static-2.10704",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.971",
  "calling-error-reporting": "static-1.31663",
  "shared-worker-versioning": "static-1.11375",
  "calling-usage-tracker": "static-1.6870",
  "voice-sms-access-library": "static-1.2121",
  "customer-data-tracking": "static-1.7216",
  "commerce-permissions": "static-1.1111",
  "products-iframe-lib": "static-1.8638",
  "products-ui-components-shared-msw-handlers": "static-1.11051",
  "crm-index-associations-lib": "static-1.6779",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10752",
  "sales-views-client-types": "static-1.4591",
  "location-customization-utils-lib": "static-1.10156",
  "apollo-dlb": "static-3.98",
  "immerable": "static-1.4480",
  "video-components-external": "static-1.12196",
  "video-data-lib": "static-1.35854",
  "bark-lib": "static-1.16849",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.102",
  "crm-properties-common-lib": "static-1.6224",
  "react-codemirror": "static-1.10977",
  "data-agent-kit": "static-1.691",
  "feedback-loader": "static-1.29851",
  "fsm": "static-1.4086",
  "policy-lib": "static-1.7138",
  "react-colorpicker": "static-2.10547",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10815",
  "embedded-academy-lib": "static-1.15605",
  "hubs-service-types": "static-1.1594",
  "salesImages": "static-1.594",
  "FileManagerLib": "static-1.40212",
  "NamespacedHubStyle": "static-2.9288",
  "FileManagerCore": "static-1.40071",
  "content-assistance-lib": "static-1.8238",
  "layout-dnd-components": "static-1.13013",
  "layout-dnd-utils": "static-1.11988",
  "ui-addon-emoji-picker": "static-1.10218",
  "ui-brand-identity-lib": "static-1.16599",
  "InboxConnectUtils": "static-4.15609",
  "meetings-connect-utils-lib": "static-1.7944",
  "breeze-engine-chat-components": "static-1.796",
  "breeze-engine-core": "static-1.1096",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "universal-page-editor-lib": "static-1.3343",
  "adobe-sign-auth-lib": "static-1.520",
  "ads-unified-auth-lib": "static-1.1492",
  "custom-vendor-connection-lib": "static-1.21",
  "google-sheets-integration-lib": "static-1.1085",
  "microsoft-drive-auth-lib": "static-1.200",
  "surveymonkey-integration-lib": "static-1.539",
  "slack-ui-library": "static-1.10733",
  "calling-orchestration-schema": "static-1.36898",
  "crm-record-cards-service-types": "static-1.3796",
  "content-media-composition-data-lib": "static-1.13306",
  "content-media-compositions": "static-2.17313",
  "media-bridge-lib": "static-1.19445",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16418",
  "browser-eslint": "static-2.57",
  "trellis-story-utils": "static-1.4841",
  "storybook-react": "static-1.40",
  "academy-common-lib": "static-1.15065",
  "audio-components": "static-1.6386",
  "FileManagerImages": "static-1.37723",
  "video-components": "static-1.14198",
  "breeze-artifacts-sdk": "static-1.439",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.61",
  "urlinator": "static-1.4864",
  "video-embed": "static-1.36688",
  "ui-addon-video-player": "static-1.9036",
  "ui-coaching-tips": "static-1.29362",
  "ContentData": "static-1.69259",
  "layout-data-lib": "static-1.10313",
  "academy-service-client": "static-1.4026",
  "croppie": "static-2.10",
  "SafeStorage": "static-1.4740",
  "trellis-ecosystem": "static-1.7667",
  "ui-addon-react-router-dom": "static-1.9866",
  "wootric-nps": "static-1.7223",
  "social-insights-client-types": "static-1.22706",
  "outpost": "static-1.4488",
  "growth-onboarding-feedback-components": "static-1.6919",
  "advanced-menus-core": "static-1.15618",
  "advanced-menus-lib": "static-1.12490",
  "ExportDialog": "static-6.10712",
  "ui-memberships-settings-lib": "static-1.34896",
  "marketplace-ui-apps-core": "static-1.19323",
  "marketplace-ui-common": "static-1.20791",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15617",
  "simple-menus-lib": "static-1.17134",
  "settings-ui-lib": "static-1.12858",
  "developer-experience-shared-components": "static-1.10873",
  "immutable-less": "static-1.4985",
  "marketplace-ui-client-types": "static-1.18198",
  "ui-addon-integrations-directory-panel": "static-2.8361",
  "ui-extensibility-client-types": "static-1.4251",
  "ai-settings-ui-library": "static-1.8384",
  "nav-meta": "static-1.30524",
  "ui-product-approvals-common": "static-1.1148",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4567",
  "simple-data-table": "static-1.3569"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.35265",
  "atom": "/atom/static-1.5416",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2815",
  "client-types": "/client-types/static-1.501",
  "cssUtils": "/cssUtils/static-1.956",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41005",
  "customer-data-objects": "/customer-data-objects/static-1.8032",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8432",
  "documents-lib": "/documents-lib/static-1.35270",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.372",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86634",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5060",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2527",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.111",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5924",
  "hs-test-utils": "/hs-test-utils/static-1.8367",
  "hub-http": "/hub-http/static-1.6546",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyle": "/HubStyle/static-2.12132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11825",
  "I18n": "/I18n/static-7.1678",
  "icons": "/icons/static-2.692",
  "jasmine-immutable": "/jasmine-immutable/static-1.3354",
  "jasmine-runner": "/jasmine-runner/static-1.6784",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7487",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.3227",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5729",
  "quartz": "/quartz/static-1.7497",
  "react": "/react/static-7.196",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.79",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-rhumb-remove-redundant-softnav.2",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5578",
  "react-virtualized": "/react-virtualized/static-2.107",
  "reference-resolvers": "/reference-resolvers/static-1.8514",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8438",
  "reporting-data": "/reporting-data/static-1.68903",
  "reporting-reports": "/reporting-reports/static-1.68580",
  "reporting-snowflake": "/reporting-snowflake/static-1.57520",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10836",
  "reporting-visualizations": "/reporting-visualizations/static-1.60978",
  "reselect": "/reselect/static-3.12",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9286",
  "sanitize": "/sanitize/static-1.4806",
  "sanitize-text": "/sanitize-text/static-1.8491",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2077",
  "signup-constants": "/signup-constants/static-1.19677",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8394",
  "StyleGuideUI": "/StyleGuideUI/static-3.506",
  "superstore": "/superstore/static-1.5093",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.97",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5090",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11318",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11432",
  "ui-images": "/ui-images/static-2.1260",
  "UIComponents": "/UIComponents/static-3.8771",
  "usage-tracker": "/usage-tracker/static-1.7647",
  "usage-tracker-container": "/usage-tracker-container/static-1.7637",
  "usage-tracker-core": "/usage-tracker-core/static-1.7497",
  "viral-links-lib": "/viral-links-lib/static-1.7410",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9987",
  "foundations-components": "/foundations-components/static-1.8537",
  "immutable": "/immutable/static-2.87",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1275",
  "quartz-core": "/quartz-core/static-1.6716",
  "quick-fetch": "/quick-fetch/static-1.4150",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.80",
  "redux-thunk": "/redux-thunk/static-2.80",
  "rpc-client-utils": "/rpc-client-utils/static-1.4999",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11480",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18421",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "metrics-js": "/metrics-js/static-1.9963",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3774",
  "quartz-webpack": "/quartz-webpack/static-1.3721",
  "foundations-assets": "/foundations-assets/static-1.5220",
  "foundations-theming": "/foundations-theming/static-1.4811",
  "hub-http-janus": "/hub-http-janus/static-1.886",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10669",
  "hubspotter-http": "/hubspotter-http/static-1.4886",
  "sassPrefix": "/sassPrefix/static-1.223",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7582",
  "crm-message-bus": "/crm-message-bus/static-1.43823",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23440",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13365",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13513",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10165",
  "events-data-lib": "/events-data-lib/static-1.582",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4244",
  "hs-resources": "/hs-resources/static-1.526",
  "immer": "/immer/static-1.101",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4070",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1341",
  "onboarding-scopes": "/onboarding-scopes/static-1.6787",
  "onboarding-tours": "/onboarding-tours/static-1.17168",
  "pulse": "/pulse/static-1.963",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14519",
  "stylex": "/stylex/static-1.41",
  "trellis-assets": "/trellis-assets/static-1.2727",
  "trellis-components": "/trellis-components/static-1.2746",
  "trellis-theming": "/trellis-theming/static-1.1307",
  "ui-addon-teams": "/ui-addon-teams/static-1.21943",
  "quartz-auth": "/quartz-auth/static-1.1172",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9425",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5333",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9779",
  "ContentUtils": "/ContentUtils/static-1.69184",
  "customer-data-properties": "/customer-data-properties/static-1.52675",
  "forms-ai-lib": "/forms-ai-lib/static-1.4802",
  "forms-utils-lib": "/forms-utils-lib/static-1.13132",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6020",
  "react-dnd-compat": "/react-dnd-compat/static-1.4951",
  "react-tinymce": "/react-tinymce/static-1.56031",
  "tinymce-config": "/tinymce-config/static-2.55157",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10630",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3796",
  "HeadJS": "/HeadJS/static-2.802",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3478",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "hs-locale-management": "/hs-locale-management/static-1.317",
  "ui-fonts": "/ui-fonts/static-1.1087",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4646",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.1162",
  "web-vitals": "/web-vitals/static-1.15",
  "batch-promise": "/batch-promise/static-1.1879",
  "external-options-client-types": "/external-options-client-types/static-1.4363",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7228",
  "quartz-i18n": "/quartz-i18n/static-1.1172",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8252",
  "graphql": "/graphql/static-1.89",
  "persist-promise": "/persist-promise/static-1.4036",
  "reporting-client-types": "/reporting-client-types/static-1.2712",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "growth-payments-core": "/growth-payments-core/static-1.26243",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5211",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1562",
  "quartz-routing": "/quartz-routing/static-1.927",
  "hs-story-utils": "/hs-story-utils/static-1.9760",
  "react-flip-move": "/react-flip-move/static-1.78",
  "nested-table": "/nested-table/static-1.569",
  "seat-types-lib": "/seat-types-lib/static-1.793",
  "timezone-utils": "/timezone-utils/static-2.5577",
  "react-create-root-preference": "/react-create-root-preference/static-1.77",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4806",
  "floating-ui": "/floating-ui/static-1.63",
  "react-aria": "/react-aria/static-1.72",
  "tanstack-table": "/tanstack-table/static-1.61",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.110",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.582",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.485",
  "quartz-test": "/quartz-test/static-1.1172",
  "quartz-tracking": "/quartz-tracking/static-1.876",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.409",
  "chirp-fetch": "/chirp-fetch/static-1.2230",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "purchase-motions-components": "/purchase-motions-components/static-1.6405",
  "ts-schema": "/ts-schema/static-1.4316",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3294",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1731",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4991",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4039",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4370",
  "event-emitter": "/event-emitter/static-1.1289",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.347",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3930",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19301",
  "growth-data-modal": "/growth-data-modal/static-1.5934",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3399",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2743",
  "navigation-components": "/navigation-components/static-1.18887",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5383",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1235",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10603",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7984",
  "ui-universal-auth": "/ui-universal-auth/static-1.9457",
  "user-context": "/user-context/static-1.5455",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.466",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "stylex-utils": "/stylex-utils/static-1.146",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10667",
  "magpie-lib": "/magpie-lib/static-1.5780",
  "navigation-messaging": "/navigation-messaging/static-1.8214",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.23177",
  "copilot-toolkit": "/copilot-toolkit/static-1.11895",
  "cms-field-types": "/cms-field-types/static-1.5146",
  "content-icons-ui": "/content-icons-ui/static-1.2397",
  "integrations-lib": "/integrations-lib/static-1.17112",
  "calling-global-api": "/calling-global-api/static-1.65709",
  "calling-internal-common": "/calling-internal-common/static-1.31656",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67091",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59385",
  "commerce-products-lib": "/commerce-products-lib/static-1.10599",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4581",
  "crm-links": "/crm-links/static-1.6658",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9996",
  "file-manager-components": "/file-manager-components/static-1.24572",
  "formula-editor": "/formula-editor/static-1.14810",
  "google-libphonenumber": "/google-libphonenumber/static-1.45",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4451",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.969",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49745",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4205",
  "property-value-citations": "/property-value-citations/static-1.3289",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.188",
  "smart-property-lib": "/smart-property-lib/static-1.8358",
  "tiered-pricing": "/tiered-pricing/static-1.2005",
  "topics-actions-lib": "/topics-actions-lib/static-1.503",
  "trial-components-library": "/trial-components-library/static-1.14156",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9411",
  "zustand": "/zustand/static-1.85",
  "final-form": "/final-form/static-1.78",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "rich-text-lib": "/rich-text-lib/static-1.20347",
  "tinymce-themes": "/tinymce-themes/static-1.57127",
  "data-token-picker": "/data-token-picker/static-1.16927",
  "hub-http-contrib": "/hub-http-contrib/static-1.3374",
  "interframe": "/interframe/static-3.5089",
  "tinymce-data": "/tinymce-data/static-1.41242",
  "tinymce-plugins": "/tinymce-plugins/static-1.58271",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5548",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7133",
  "ui-addon-opt": "/ui-addon-opt/static-4.8701",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.670",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.482",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.38",
  "purchase-motions-api": "/purchase-motions-api/static-1.6408",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2557",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2771",
  "user-context-client": "/user-context-client/static-1.4842",
  "idb-keyval": "/idb-keyval/static-1.51",
  "magpie-types": "/magpie-types/static-1.5240",
  "nest": "/nest/static-1.571",
  "reactive-lib": "/reactive-lib/static-1.1053",
  "simple-logging-lib": "/simple-logging-lib/static-1.3385",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1253",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18419",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1818",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14527",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5942",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8111",
  "redux-observable": "/redux-observable/static-1.75",
  "ReduxMessenger": "/ReduxMessenger/static-2.10704",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.971",
  "calling-error-reporting": "/calling-error-reporting/static-1.31663",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11375",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6870",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2121",
  "customer-data-tracking": "/customer-data-tracking/static-1.7216",
  "commerce-permissions": "/commerce-permissions/static-1.1111",
  "products-iframe-lib": "/products-iframe-lib/static-1.8638",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11051",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6779",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10752",
  "sales-views-client-types": "/sales-views-client-types/static-1.4591",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10156",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "immerable": "/immerable/static-1.4480",
  "video-components-external": "/video-components-external/static-1.12196",
  "video-data-lib": "/video-data-lib/static-1.35854",
  "bark-lib": "/bark-lib/static-1.16849",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.102",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6224",
  "react-codemirror": "/react-codemirror/static-1.10977",
  "data-agent-kit": "/data-agent-kit/static-1.691",
  "feedback-loader": "/feedback-loader/static-1.29851",
  "fsm": "/fsm/static-1.4086",
  "policy-lib": "/policy-lib/static-1.7138",
  "react-colorpicker": "/react-colorpicker/static-2.10547",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10815",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15605",
  "hubs-service-types": "/hubs-service-types/static-1.1594",
  "salesImages": "/salesImages/static-1.594",
  "FileManagerLib": "/FileManagerLib/static-1.40212",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9288",
  "FileManagerCore": "/FileManagerCore/static-1.40071",
  "content-assistance-lib": "/content-assistance-lib/static-1.8238",
  "layout-dnd-components": "/layout-dnd-components/static-1.13013",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11988",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10218",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16599",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15609",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7944",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.796",
  "breeze-engine-core": "/breeze-engine-core/static-1.1096",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3343",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.520",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1492",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.21",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1085",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.200",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.539",
  "slack-ui-library": "/slack-ui-library/static-1.10733",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36898",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13306",
  "content-media-compositions": "/content-media-compositions/static-2.17313",
  "media-bridge-lib": "/media-bridge-lib/static-1.19445",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16418",
  "browser-eslint": "/browser-eslint/static-2.57",
  "trellis-story-utils": "/trellis-story-utils/static-1.4841",
  "storybook-react": "/storybook-react/static-1.40",
  "academy-common-lib": "/academy-common-lib/static-1.15065",
  "audio-components": "/audio-components/static-1.6386",
  "FileManagerImages": "/FileManagerImages/static-1.37723",
  "video-components": "/video-components/static-1.14198",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.439",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.61",
  "urlinator": "/urlinator/static-1.4864",
  "video-embed": "/video-embed/static-1.36688",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9036",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29362",
  "ContentData": "/ContentData/static-1.69259",
  "layout-data-lib": "/layout-data-lib/static-1.10313",
  "academy-service-client": "/academy-service-client/static-1.4026",
  "croppie": "/croppie/static-2.10",
  "SafeStorage": "/SafeStorage/static-1.4740",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7667",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9866",
  "wootric-nps": "/wootric-nps/static-1.7223",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "outpost": "/outpost/static-1.4488",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6919",
  "advanced-menus-core": "/advanced-menus-core/static-1.15618",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12490",
  "ExportDialog": "/ExportDialog/static-6.10712",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34896",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19323",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20791",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15617",
  "simple-menus-lib": "/simple-menus-lib/static-1.17134",
  "settings-ui-lib": "/settings-ui-lib/static-1.12858",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10873",
  "immutable-less": "/immutable-less/static-1.4985",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18198",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8361",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4251",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8384",
  "nav-meta": "/nav-meta/static-1.30524",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1148",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4567",
  "simple-data-table": "/simple-data-table/static-1.3569"
}
};
